import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column flex-root"
}
const _hoisted_2 = { class: "page d-flex flex-row flex-column-fluid" }
const _hoisted_3 = {
  key: 1,
  id: "kt_wrapper",
  class: "d-flex flex-column flex-row-fluid wrapper"
}
const _hoisted_4 = {
  id: "kt_content",
  class: "content d-flex flex-column flex-column-fluid"
}
const _hoisted_5 = { class: "post d-flex flex-column-fluid" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "sidebars-container" }
const _hoisted_8 = {
  key: 0,
  style: {"padding-bottom":"80px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Aside = _resolveComponent("Aside")!
  const _component_Header = _resolveComponent("Header")!
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ScrollTop = _resolveComponent("ScrollTop")!

  return (_ctx.clientBrandingState.notFound)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "d-flex flex-column flex-column-fluid align-items-center justify-content-center p-10 text-center" }, [
          _createElementVNode("h1", { class: "text-dark mb-4" }, " Nieznana domena klienta "),
          _createElementVNode("p", { class: "text-muted mb-0" }, " Ta domena nie jest przypisana do panelu klienta. ")
        ], -1)
      ]))]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(_component_Loader),
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.$route.meta.hideMenu)
            ? (_openBlock(), _createBlock(_component_Aside, { key: 0 }))
            : _createCommentVNode("", true),
          (!_ctx.$route.meta.hideMenu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_Header, {
                  "page-name": _ctx.pageName,
                  onToggleSidebar: _ctx.openSidebarWithComponent
                }, null, 8, ["page-name", "onToggleSidebar"]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sidebars, (sidebar, index) => {
                          return (_openBlock(), _createBlock(_component_SideBar, {
                            key: index,
                            "is-visible": true,
                            title: sidebar.title,
                            "component-name": sidebar.componentName,
                            position: sidebar.position,
                            level: sidebar.level,
                            props: sidebar.props,
                            onOpenChild: _ctx.openSidebarWithComponent,
                            onClose: _ctx.closeSidebar
                          }, null, 8, ["title", "component-name", "position", "level", "props", "onOpenChild", "onClose"]))
                        }), 128))
                      ]),
                      _createVNode(_component_router_view, { onPageName: _ctx.setPageName }, null, 8, ["onPageName"])
                    ])
                  ]),
                  (_ctx.$refs.scrollRef?.getState())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createBlock(_component_router_view, {
                key: 2,
                onPageName: _ctx.setPageName
              }, null, 8, ["onPageName"]))
        ]),
        _createVNode(_component_ScrollTop, { ref: "scrollRef" }, null, 512)
      ], 64))
}